import React from "react"

import TimeReport from "../../../../../model2/time-report/time-report"
import {EntityType} from "../../../../../gd/const/item"
import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5"
import Task from "../../../../../model2/task/task"
import Project from "../../../../../model2/project/project"
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../gd-components/icons/@const"

type Props = {
    timeReport: TimeReport
}

export default function WorkItemIcon(props: Props): React.ReactElement | null {
    const entity = props.timeReport.entity
    if (!entity) return null

    switch (entity.itemType) {
        case EntityType.TASK:
            return (
                <TaskTypeIcon
                    className   = "flex-no-shrink m-r-5"
                    taskTypeId  = {(entity as Task).taskTypeId}
                />
            )
        case EntityType.PROJECT:
            return (
                <ProjectIconUI5
                    className   = "flex-no-shrink m-r-5"
                    project     = {entity as Project}
                    size        = {ItemIconSize.SIZE_13}
                />
            )
        case EntityType.MEETING:
            return <div className="ui5-ico-13 i5-meeting flex-no-shrink m-r-5"/>
        default:
            return null
    }
}
